enum FundAssetClassType {
  AKSJEFOND = 'Aksjefond',
  OBLIGASJONSFOND = 'Obligasjonsfond',
  KOMBINASJONSFOND = 'Kombinasjonsfond',
  PENGEMARKEDSFOND = 'Pengemarkedsfond',
  ANNENSPARING = 'Annensparing',
  BANKSPARING = 'BankSparing',
  FORSIKRINGSSPARING = 'Forsikringssparing',
  AKSJER = 'Aksjer',
  UDEFINERT = 'Udefinert',
}

export default FundAssetClassType;
